module.exports = __webpack_public_path__ + "static/media/0.20f650d3.jpg";